module.exports = __webpack_public_path__ + "static/media/logo-edit.4f8d0611.png";